module.exports = __webpack_public_path__ + "media/images/iconArrowLeft--dark-d1b554710f87e7086c52fa6bdc4e8b61.png";